<template>
    <div class="uik-indicator">
        <div
            v-if="icon"
            class="uik-indicator__icon-widget"
        >
            <UikIcon
                class="uik-indicator__icon"
                :class="`uik-indicator__icon--${color}`"
                type="far"
                :icon="icon"
            />
        </div>
        <UikData
            class="uik-indicator__data"
            :title="title"
            :content="content"
            :trend="trend"
            :trend-type="trendType"
            :trend-direction="trendDirection"
            size="small"
        />
        <div
            v-if="$slots.default"
            class="uik-indicator__additional-component"
        >
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
    name: "UikIndicator",
    props: {
        /**
         * Indicator icon
         */
        icon: {
            type: String,
            default: ""
        },
        /**
         * Text above data
         */
        title: {
            type: String,
            default: ""
        },
        /**
         * Displayed data
         */
        content: {
            type: String,
            default: ""
        },
        /**
         * Trend value (not displayed if there's no value)
         */
        trend: {
            type: String,
            default: ""
        },
        /**
         * Trend type - defines color
         */
        trendType: {
            type: String,
            default: "good",
            validator (value) {
                return [
                    "good",
                    "bad"
                ].indexOf(value) !== -1
            }
        },
        /**
         * Direction the trend arrow is pointing at
         */
        trendDirection: {
            type: String,
            default: "up",
            validator (value) {
                return [
                    "up",
                    "down"
                ].indexOf(value) !== -1
            }
        },
        /**
         * Icon color
         */
        color: {
            type: String,
            default: "primary",
            validator (value) {
                return [
                    "primary",
                    "secondary",
                    "success",
                    "warning",
                    "error",
                    "red",
                    "orange",
                    "yellow",
                    "lime",
                    "green",
                    "cyan",
                    "blue",
                    "purple",
                    "pink",
                    "gray"
                ].indexOf(value) !== -1
            }
        }
    }
}
</script>

<style lang="scss">
.uik-indicator {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: flex-end;

    .uik-indicator__icon-widget {
        background: white;
        border-radius: 8px;
        height: 42px;
        width: 42px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0 2px 5px -2px rgba($textMain, 0.15), 0 2px 15px -5px rgba($textMain, 0.15), 0 5px 10px -5px rgba($textMain, 0.05);

        .uik-indicator__icon {
            font-size: 18px;

            @each $name, $color in $colors {
                &--#{"" + $name} {
                    color: $color;
                }
            }

            @each $name, $color in $projectColors {
                &--#{"" + $name} {
                    color: $color;
                }
            }
        }

        & + .uik-indicator__data {
            margin-left: 15px;
        }
    }

    .uik-indicator__additional-component {
        margin-left: 18px;
        padding-bottom: 5px;

        .uik-progress {
            .uik-progress__line {
                .uik-progress__line-label {
                    display: none;
                }
            }

            .uik-progress__progress {
                margin-left: 0;

                .uik-progress__line-text-wrapper {
                    .uik-progress__line-text {
                        white-space: nowrap;
                        word-break: initial;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        max-width: 100%;
                    }
                }

                .uik-progress__line-wrapper {
                    padding: 2px 0 1px 0;
                }
            }
        }

        .uik-progress-bars {
            .uik-progress {
                & + .uik-progress {
                    margin-top: 3px;
                }
            }
        }

        .uik-bars {
            height: 32px;

            .uik-bars__bar-wrapper {
                $width: 5px;
                width: calc(#{$width} + 4px);
                padding: 0 2px;

                .uik-bars__bar {
                    width: calc(#{$width} - 2px);
                }

                .uik-bars__bar-fill {
                    width: $width;
                    left: 2px;
                }
            }
        }

        .uik-shares {
            .uik-shares__share-wrapper {
                padding: 5px 0 1px 0;
            }
        }
    }
}
</style>
